/**
 * Centre Page settling in — age-personalised panels.
 */
(function () {
	'use strict';

	function switchSettling(age) {
		var root = document.querySelector('[data-centre-settling]');
		if (!root) {
			return;
		}

		var slug = age && 'default' !== age ? age : 'default';

		root.querySelectorAll('[data-settling-panel]').forEach(function (panel) {
			var isActive = panel.getAttribute('data-settling-panel') === slug;
			panel.classList.toggle('is-active', isActive);
			if (isActive) {
				panel.removeAttribute('hidden');
			} else {
				panel.setAttribute('hidden', '');
			}
		});
	}

	window.guardianCentrePageSwitchSettling = switchSettling;

	function init() {
		if (!document.querySelector('[data-centre-settling]')) {
			return;
		}
		switchSettling('default');
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
